import React, { useState, useEffect } from 'react';
import API from '../services/api';

const SystemStatusDetailed = () => {
  const [stats, setStats] = useState([
    { label: "Database", value: "Loading...", type: "text", color: "hsl(162,72%,47%)" },
    { label: "API Response", value: "...", type: "progress", percent: 0, color: "hsl(162,72%,47%)" },
    { label: "Storage", value: "...", type: "progress", percent: 0, color: "hsl(24,95%,53%)" },
    { label: "Uptime", value: "...", type: "text", color: "hsl(162,72%,47%)" },
  ]);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await API.get('/admin/system/status');
        const data = res.data?.data;
        if (data) {
          setStats([
            { label: "Database", value: data.database, type: "text", color: "hsl(162,72%,47%)" },
            { label: "API Response", value: data.apiResponse, type: "progress", percent: Math.min(100, Math.max(0, 100 - data.dbLatency)), color: "hsl(162,72%,47%)" },
            { label: "Storage", value: `${data.storageUsedPercent}% Used`, type: "progress", percent: data.storageUsedPercent, color: data.storageUsedPercent > 80 ? "hsl(0,84%,60%)" : "hsl(24,95%,53%)" },
            { label: "Uptime", value: data.uptimeString || "99.9%", type: "text", color: "hsl(162,72%,47%)" },
          ]);
        }
      } catch (e) {
        console.error("Failed to fetch system status", e);
      }
    };
    fetchStatus();
    const interval = setInterval(fetchStatus, 30000); // refresh every 30s
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      background: "hsl(var(--card))",
      padding: "24px",
      borderRadius: "16px",
      border: "1px solid hsl(var(--border))"
    }}>
      <h3 style={{ margin: "0 0 20px 0", fontSize: "16px", fontWeight: "700", color: "hsl(var(--foreground))" }}>System Status</h3>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {stats.map((stat, i) => (
          <div key={i} style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: "13px", color: "hsl(var(--muted-foreground))", fontWeight: "500" }}>{stat.label}</span>
              <span style={{ fontSize: "13px", fontWeight: "700", color: stat.color }}>{stat.value}</span>
            </div>

            {stat.type === "progress" && (
              <div style={{ width: "100%", height: "6px", background: "hsl(var(--muted))", borderRadius: "10px", overflow: "hidden" }}>
                <div style={{
                  width: `${stat.percent}%`,
                  height: "100%",
                  background: stat.color,
                  borderRadius: "10px",
                  transition: "width 1s ease-in-out"
                }} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SystemStatusDetailed;